import React from 'react';
import { StyleSheet, Text } from 'react-native';

import { fonts } from '_theme/index';

export const Paragraph = ({ style, size = 'm', ...otherProps }) => {
    let textStyle = fonts?.fontStyles?.paragraph[size]
    return (
        <Text
            style={[textStyle, style]}
            {...otherProps}
        />
    );
};